module.exports = __webpack_public_path__ + "logo-small.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo-small.png
// module id = 139
// module chunks = 0